import { globalHistory } from '@reach/router'

import { getParam } from '@cinch/oxd-utils/browser-support/src'

export default function (): object {
  if (!globalHistory || !globalHistory.location || !globalHistory.location.search) {
    return {}
  }

  // fetch the query strings from the url
  const { search } = globalHistory.location

  // whitelist url parameters so we don't apply the wrong ones to initialValues
  const params = [
    'fromPrice',
    'toPrice',
    'fromYear',
    'toYear',
    'mileage',
    'fromEngineSize',
    'toEngineSize',
    'sortingCriteria',
    'pageSize',
    'longitude',
    'latitude',
    'distance',
    'colour',
    'doors',
    'fuelType',
    'transmissionType',
    'bodyType',
    'make',
    'selectedModel',
    'pageNumber',
    'query',
    'location',
    'deliveryOption',
    'cid',
    'icid',
  ]

  const qs = getParam(search)

  return params.reduce((allParams, param) => {
    const value = qs(param)

    if (value !== '') {
      return { ...allParams, [param]: isNaN(+value) ? value : parseFloat(value) }
    }

    return allParams
  }, {})
}
